export function extractPropertiesFromJsonObject(jsonObject) {
  const formBody = Object.keys(jsonObject).reduce((acc, key) => {
    const value = jsonObject[key]
    if (value === undefined || value === null) {
      return acc
    }
    if (value instanceof Array) {
      const arrayItem = value.reduce((accArray, valueArray) => {
        if (valueArray instanceof Object) {
          accArray.push(
            `${encodeURIComponent(key)}=${encodeURIComponent(JSON.stringify(valueArray))}`,
          )
        } else {
          accArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(valueArray)}`)
        }
        return accArray
      }, [])
      return acc.concat(arrayItem)
    }
    if (value instanceof Object) {
      acc.push(`${encodeURIComponent(key)}=${encodeURIComponent(JSON.stringify(value))}`)
    } else {
      acc.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    }
    return acc
  }, [])
  return formBody.join('&')
}



/**
 * Safely converts an object to a JSON string.
 * @param {any} obj - The object or JSON string to convert.
 * @returns {string|null} - JSON string if successful, or null if failed.
 */
export function safeJSONStringify(obj) {
  try {
    if (typeof obj === 'string') {
      JSON.parse(obj); // throws if invalid
      return obj;
    }
    return JSON.stringify(obj, null, 2);
  } catch (error) {
    console.error('JSON conversion failed:', error);
    return null;
  }
}

/**
 * Attempts to fix and parse a malformed JSON string.
 * @param {string} input - Possibly malformed JSON string.
 * @returns {object|null} - Parsed object or null if failed.
 */
export function fixAndParseJSON(input) {

  try {
    const cleaned = input
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&amp;/g, '&')
      .replace(/&nbsp;/g, ' ')
      .replace(/&br\s*\/&gt;/g, '')
      .replace(/'/g, '"');
    console.log("fixAndParseJSON :", cleaned , JSON.parse(cleaned))
    return JSON.parse(cleaned);
  } catch (error) {
    console.error('Failed to fix/parse JSON:', error);
    
    return null;
  }
}


const decodeHtmlEntities = (str) => {
  return str
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, '&')
    .replace(/<br\s*\/?>/gi, '') // remove <br />
};


export const safeParseJSON = (input) => {
  try {
    if (typeof input === 'object') return input;

    if (typeof input === 'string') {
      const decoded = decodeHtmlEntities(input);
      const corrected = decoded.replace(/'/g, '"'); // replace single quotes
      return JSON.parse(corrected);
    }

    console.error('Unsupported input type:', typeof input);
    return null;
  } catch (e) {
    console.error('❌ Invalid JSON:', e.message);
    console.warn('🔍 Raw input:', input);
    return null;
  }
};



export const htmlToPlainText = (htmlString) => {
  if (!htmlString) return '';

  const parser = new DOMParser();

  // Decode double-encoded HTML
  const firstDecode = parser.parseFromString(htmlString, 'text/html').documentElement.textContent;
  const doc = parser.parseFromString(firstDecode, 'text/html');

  const text = doc.body.innerHTML
    .replace(/<br\s*\/?>/gi, '\n')    // Convert <br> to newline
    .replace(/<\/p>/gi, '\n')         // Convert </p> to newline
    .replace(/<[^>]+>/g, '')  
    .replace(/&nbsp;/gi, ' ')         // Replace HTML non-breaking spaces
    .replace(/\u00A0/g, ' ')          // Replace Unicode non-breaking spaces
    .replace(/\s+\n/g, '\n')          // Clean spaces before newline
    .replace(/\n{2,}/g, '\n')         // Remove multiple blank lines
    .trim();

  return text;
};



/**
 * Decodes HTML entities like &lt; &gt; &amp; into actual characters (<, >, &).
 * Works in browsers using DOMParser.
 */
export const decodeHtmlEntitiesFn = (htmlEscapedString = '') =>{
    if (!htmlEscapedString || typeof htmlEscapedString !== 'string') return '';
    const parser = new DOMParser();
    // Wrap it to ensure valid parsing for fragments
    const doc = parser.parseFromString(`<!doctype html><body>${htmlEscapedString}`, 'text/html');
    return doc.body.textContent || '';
  }